__turbopack_context__.v({
  "indicatorBadge": "IndicatorBadge-module__5Ug4va__indicatorBadge",
});
